import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Activity, CreditCard, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useCustomerAuth } from '@/contexts/CustomerAuthContext';

export default function CustomerDashboard() {
  const { provider } = useCustomerAuth();
  const { t } = useTranslation();

  const portalLabel = provider?.name ?? t('customer.dashboard.defaultPortalName');
  const providerLabel = provider?.name ?? t('customer.dashboard.providerFallback');
  const usageRequestsCount = 0;

  return (
    <div className="space-y-8">
      <div className="space-y-2 text-center md:text-left">
        <h1 className="text-3xl font-bold">
          {t('customer.dashboard.welcome', { portal: portalLabel })}
        </h1>
        <p className="text-muted-foreground">
          {t('customer.dashboard.subtitle', { provider: providerLabel })}
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">
              {t('customer.dashboard.cards.usage.title')}
            </CardTitle>
            <Activity className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {t('customer.dashboard.cards.usage.value', { count: usageRequestsCount })}
            </div>
            <p className="text-xs text-muted-foreground">
              {t('customer.dashboard.cards.usage.description')}
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">
              {t('customer.dashboard.cards.billing.title')}
            </CardTitle>
            <CreditCard className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {t('customer.dashboard.cards.billing.value')}
            </div>
            <p className="text-xs text-muted-foreground">
              {t('customer.dashboard.cards.billing.description')}
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">
              {t('customer.dashboard.cards.teams.title')}
            </CardTitle>
            <ShieldCheck className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {t('customer.dashboard.cards.teams.value')}
            </div>
            <p className="text-xs text-muted-foreground">
              {t('customer.dashboard.cards.teams.description')}
            </p>
          </CardContent>
        </Card>

      </div>

    </div>
  );
}
